import { render, staticRenderFns } from "./BridgeSystemQueueOrderPage.vue?vue&type=template&id=575c0834&scoped=true&"
import script from "./BridgeSystemQueueOrderPage.vue?vue&type=script&lang=ts&"
export * from "./BridgeSystemQueueOrderPage.vue?vue&type=script&lang=ts&"
import style0 from "./BridgeSystemQueueOrderPage.vue?vue&type=style&index=0&id=575c0834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c0834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VSelect,VSimpleTable,VTextField})
